export default __webpack_public_path__ + "assets/images/9bf985628aa1469eefeca9072d489f4d.png";